import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { type LoaderInitialState } from './types';

const initialState: LoaderInitialState = {
  pendingCalls: {},
};

export const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    startPendingCall: (state, { payload }: PayloadAction<string>) => {
      state.pendingCalls[payload] = true;
    },
    stopPendingCall: (state, { payload }: PayloadAction<string>) => {
      state.pendingCalls[payload] = false;
    },
  },
});

export const { reducer: loaderReducer } = loaderSlice;
